import React from 'react';
import { Typography } from '@mui/material';

const ErrorPage = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            backgroundColor: '#ffd300',
            fontFamily: 'sans-serif',
            fontSize: '20px'
        }}>
            <Typography>An error occured. We are sorry. Click <a href="/">here</a> to go to the homepage.</Typography>
        </div>
    );
}

export default ErrorPage;
